<app-o2o-order-view
  titleKey="order.internal.view.title"
  summarySectionTitleKey="order.internal.summary.title"
  formMode="standard_sales"
  [createConfigFactory]="createConfigFactory"
  backRoute="/order/internal"
  permissionPrefix="orders.standard_sales_orders"
  [enableSse]="false"
  [enableEditButton]="true"
></app-o2o-order-view>
